<template>
  <ul class="nav navbar-nav mr-auto" v-if="!isCliente">
    <Menubar :model="menuItems" class="p-0 border-0 bg-transparent nav-menu">
      <template #item="{ item, props }">
        <router-link v-if="item.to" v-bind="props.action" :to="item.to" class="menu-item-link">
          <i :class="item.icon"></i>
          <span class="ml-2">{{ item.label }}</span>
        </router-link>
        <a v-else v-bind="props.action" :href="item.url || '#'" class="menu-item-link">
          <i :class="item.icon"></i>
          <span class="ml-2">{{ item.label }}</span>
          <i v-if="item.items" class="pi pi-angle-down ml-2"></i>
        </a>
      </template>
    </Menubar>
  </ul>

  <ul class="nav navbar-top-links ml-auto">
    <li>
      <ButtonDarkMode/>
    </li>
    <Divider layout="vertical"/>
    <li>
      <img v-if="userFoto && !isCliente" id="userFoto" class="img-circle" width="40px" height="40px"
           :src="'data:image/png;base64,' + userFoto" alt="Foto do Perfil">

      <img v-else class="img-circle" width="40px" height="40px" src="../../../public/img/profile.png"
           alt="Sem Foto do Perfil">

    </li>
    <li class="dropdown">

      <a v-if="!isCliente" aria-expanded="false" role="button" href="#" class="dropdown-toggle text-dark"
         data-toggle="dropdown">
        Olá, {{ primeiroNome }} {{ ultimoNome }}
        <i class="fa fa-level-down"></i>
      </a>

      <a v-else aria-expanded="false" role="button" href="#" class="dropdown-toggle text-dark" data-toggle="dropdown">
        Olá, {{ clienteNome }}
        <i class="fa fa-level-down"></i>
      </a>

      <ul role="menu" class="dropdown-menu" style="width: 200px">
        <li v-if="isAuthenticated && !isCliente" @click="abrirModal('editarPerfil')">
          <a href="#">
            <i class="fa fa-edit"></i>
            ALTERAR PERFIL
          </a>
        </li>
        <li v-if="isAuthenticated && !isCliente" @click="abrirModal('alterarSenha')">
          <a href="#">
            <i class="fa fa-key"></i>
            ALTERAR SENHA
          </a>
        </li>
        <li @click="logout">
          <a><i class="fa fa-sign-out"></i>
            SAIR</a>
        </li>

      </ul>
    </li>
  </ul>

  <AlterarSenha
      v-if="modalAtivo === 'alterarSenha'"
      :idModal="'alterarSenhaUser'"
      @fechar="fecharModal"
      :usuarioId="Number(userID)"
  />

  <EditarPerfilUser
      v-if="modalAtivo === 'editarPerfil'"
      :idModal="'editarPerfilUser'"
      @fechar="fecharModal"
      :usuarioId="Number(userID)"
  />
</template>

<script>
import {apiUrl} from "@/router/apiBackRoutes";
import EditarPerfilUser from "@/views/usuarios/EditarPerfilUser.vue";
import AlterarSenha from "@/views/usuarios/AlterarSenha.vue";
import ButtonDarkMode from "@/components/ButtonDarkMode.vue";
// Componentes PrimeVue necessários
import Menubar from 'primevue/menubar';
import Divider from 'primevue/divider';

export default {
  name: 'Menu',
  components: {
    AlterarSenha,
    EditarPerfilUser,
    ButtonDarkMode,
    Menubar,
    Divider,
  },
  data() {
    return {
      userFoto: localStorage.getItem('admin_userFoto'),
      primeiroNome: localStorage.getItem('admin_firstName'),
      ultimoNome: localStorage.getItem('admin_lastName'),
      isAuthenticated: (localStorage.getItem('admin_isAuthenticated') === 'true' || localStorage.getItem('crm_isAuthenticated') === 'true'),
      isSuperUser: localStorage.getItem('admin_isSuperUser') === 'true',
      isStaff: localStorage.getItem('admin_isStaff') === 'true',
      clienteNome: localStorage.getItem('crm_clienteNome'),
      modalAtivo: null,
      userID: localStorage.getItem('admin_userID'),
      menuItems: []
    }
  },
  computed: {
    isCliente() {
      return this.$route.path.startsWith('/crm') && localStorage.getItem('admin_isAuthenticated') !== 'true';
    }
  },
  watch: {
    isSuperUser: {
      immediate: true,
      handler() {
        this.loadMenuItems();
      }
    },
    isStaff: {
      immediate: true,
      handler() {
        this.loadMenuItems();
      }
    },
    isCliente: {
      immediate: true,
      handler() {
        this.loadMenuItems();
      }
    }
  },
  methods: {
    fecharModal() {
      this.modalAtivo = null;
    },
    abrirModal(tipo) {
      this.modalAtivo = tipo;
    },
    loadMenuItems() {
      if (this.isCliente) {
        this.menuItems = [];
        return;
      }

      const cadastrosSubmenu = [
        {label: 'CLIENTES', to: '/clientes'},
        {label: 'FORNECEDORES', to: '/fornecedores'},
        {separator: true},
        {label: 'CORRETORES', to: '/corretores'},
        {label: 'IMÓVEIS', to: '/imoveis'},
        {separator: true},
        {label: 'USUÁRIOS DO SISTEMA', to: '/usuarios'},
      ];

      const construcoesSubmenu = [
        {label: 'ETAPAS', to: '/etapas'},
        {separator: true},
        {label: 'CONSTRUÇÕES', to: '/construcoes'},
        {label: 'MATERIAIS', to: '/materiais'},
        {label: 'SERVIÇOS', to: '/servicos'},
        {separator: true},
        {label: 'ENTRADA DE MATERIAIS', to: '/compras'},
        {label: 'SAÍDA DE MATERIAIS', to: '/saidas'},
        {separator: true},
        {label: 'MODELOS CONSTRUTIVOS', to: '/modelos'},

      ];

      const operacoesSubmenu = [
        {label: 'ANÁLISES', to: '/analises'},
      ];

      const relatoriosSubmenu = [
        {label: 'ANÁLISES', to: '/analises/relatorios'},
        {label: 'CLIENTES', to: '/clientes/relatorios'},
        {label: 'COMPRAS', to: '/compras/relatorios'},
        {label: 'CONSTRUÇÕES', to: '/construcoes/relatorios'},
        {label: 'CORRETORES', to: '/corretores/relatorios'},
        {label: 'FORNECEDORES', to: '/fornecedores/relatorios'},
      ];

      const adminSubmenu = [
        {label: 'AUDITORIA', to: '/auditoria'},
        {label: 'EMPRESAS', to: '/empresas'},
        {label: 'USUÁRIOS', to: '/admin/usuarios'},
      ];

      this.menuItems = [
        {label: 'INÍCIO', icon: 'fa fa-home', to: '/'},
        ...(this.isSuperUser ? [{label: 'ADMINISTRAÇÃO', icon: 'fa fa-lock', items: adminSubmenu}] : []),
        {label: 'CADASTROS', icon: 'fa fa-users', items: cadastrosSubmenu},
        {label: 'CONSTRUÇÕES', icon: 'fa fa-university', items: construcoesSubmenu},
        {label: 'OPERAÇÕES', icon: 'fa fa-gears', items: operacoesSubmenu},
        {label: 'RELATÓRIOS', icon: 'fa fa-print', items: relatoriosSubmenu},
        {label: 'CRM', icon: 'fa fa-gear', to: '/crm/solicitacoes'},
      ];
    },
    async logout() {
      try {
        if (!this.isCliente) {
          await fetch(apiUrl.usuarios.logout, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          });
          localStorage.clear();
          this.$toastMessage("success", "Logout realizado com sucesso!");
          this.$router.push('/login');
        } else {
          await fetch(apiUrl.crm.logout, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include'
          });
          localStorage.clear();
          this.$toastMessage("success", "Logout realizado com sucesso!");
          this.$router.push('/crm/login');
        }
      } catch (error) {
        console.error('Erro ao tentar fazer logout:', error);
        localStorage.clear();
        if (this.isCliente) {
          this.$router.push('/crm/login');
        } else {
          this.$router.push('/login');
        }
      }
    }
  },
  mounted() {
    this.loadMenuItems();
  }
}
</script>

<style scoped>
.nav-menu .p-menubar {
  box-shadow: none !important;
  border: none !important;
}

.nav-menu .menu-item-link,
.p-submenu-list .menu-item-link,
.nav-menu .p-menubar-root-list > .p-menuitem > .p-menuitem-content > .p-menuitem-link,
.p-submenu-list .p-menuitem-link {
  font-weight: bold !important;
  padding: 0.5rem 0.75rem;
}

/* ---------------------------------------------------- */

.nav-menu .p-menubar .p-menuitem-separator {
  margin: 0.35rem 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

/* Outros estilos */
.img-circle {
  border-radius: 50%;
}
</style>